import { importWithReload } from '@/lib/lazyWithReload'

let cfoPagePromise

export function prefetchCfoPage() {
  cfoPagePromise ||= importWithReload(() => import('@/pages/CfoPage'))
  return cfoPagePromise
}
